import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ScrollToTop } from "@/components/ScrollToTop";
import { ThemeProvider } from "@/components/ThemeProvider";
import RequireAdmin from "@/components/auth/RequireAdmin";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";

// Admin Pages
const AdminUsers = lazy(() => import("./pages/admin/Users"));
const Admin = lazy(() => import("./pages/Admin"));


const queryClient = new QueryClient();

const App = () => (
  <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Carregando...</div>}>
    <ThemeProvider defaultTheme="system" storageKey="tupja-theme">
        <QueryClientProvider client={queryClient}>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Index />} />

                {/* Login e recuperação */}
                <Route path="/auth" element={<Auth />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verificar-email" element={<VerifyEmail />} />

                {/* Painel Administrativo */}
                <Route path="/admin" element={<RequireAdmin><Navigate to="/admin/atendimentos" replace /></RequireAdmin>} />
                <Route path="/admin/usuarios" element={<RequireAdmin><AdminUsers /></RequireAdmin>} />

                <Route path="/admin/atendimentos" element={<RequireAdmin><Admin tab="appointments" /></RequireAdmin>} />
                <Route path="/admin/calendario" element={<RequireAdmin><Admin tab="calendar" /></RequireAdmin>} />
                <Route path="/admin/gira-semanal" element={<RequireAdmin><Admin tab="weekly" /></RequireAdmin>} />
                <Route path="/admin/galeria" element={<RequireAdmin><Admin tab="gallery" /></RequireAdmin>} />
                <Route path="/admin/biblioteca" element={<RequireAdmin><Admin tab="library" /></RequireAdmin>} />
                <Route path="/admin/comunicados" element={<RequireAdmin><Admin tab="newsletter" /></RequireAdmin>} />
                <Route path="/admin/push" element={<RequireAdmin><Admin tab="notifications" /></RequireAdmin>} />
                <Route path="/admin/whatsapp" element={<RequireAdmin><Admin tab="whatsapp" /></RequireAdmin>} />
                <Route path="/admin/posts" element={<RequireAdmin><Admin tab="instagram" /></RequireAdmin>} />
                <Route path="/admin/membros-site" element={<RequireAdmin><Admin tab="members" /></RequireAdmin>} />
                <Route path="/admin/configuracoes" element={<RequireAdmin><Admin tab="settings" /></RequireAdmin>} />

                {/* Demais rotas redirecionam para a página temporária */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </TooltipProvider>
        </QueryClientProvider>
    </ThemeProvider>
  </Suspense>
);

export default App;
